export const TotalConlum = 7; // 日历展示固定列
export const TotalRow = 5;
export const ScheduleDateScope = 35;
export const ScheduleDefaultColor = "5EA7F8";
export const CalendarDefaultColor = "5EA7F8";
